// Ce fichier est genere automatiquement par tools/generate-spritesheet-config.js
// Ne pas modifier manuellement
// Dossier: parasite | Taille: 256x256px | Directions: 5

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const ParasiteSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'parasite-attack1',
    metadata: {
      frames: {
        'parasite-attack1-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack1-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/parasite/attack1.png',
        size: {
          w: 2304,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'parasite-attack1-bottom': [
          'parasite-attack1-bottom-0',
          'parasite-attack1-bottom-1',
          'parasite-attack1-bottom-2',
          'parasite-attack1-bottom-3',
          'parasite-attack1-bottom-4',
          'parasite-attack1-bottom-5',
          'parasite-attack1-bottom-6',
          'parasite-attack1-bottom-7',
          'parasite-attack1-bottom-8',
        ],
        'parasite-attack1-bottom-left': [
          'parasite-attack1-bottom-left-0',
          'parasite-attack1-bottom-left-1',
          'parasite-attack1-bottom-left-2',
          'parasite-attack1-bottom-left-3',
          'parasite-attack1-bottom-left-4',
          'parasite-attack1-bottom-left-5',
          'parasite-attack1-bottom-left-6',
          'parasite-attack1-bottom-left-7',
          'parasite-attack1-bottom-left-8',
        ],
        'parasite-attack1-left': [
          'parasite-attack1-left-0',
          'parasite-attack1-left-1',
          'parasite-attack1-left-2',
          'parasite-attack1-left-3',
          'parasite-attack1-left-4',
          'parasite-attack1-left-5',
          'parasite-attack1-left-6',
          'parasite-attack1-left-7',
          'parasite-attack1-left-8',
        ],
        'parasite-attack1-top-left': [
          'parasite-attack1-top-left-0',
          'parasite-attack1-top-left-1',
          'parasite-attack1-top-left-2',
          'parasite-attack1-top-left-3',
          'parasite-attack1-top-left-4',
          'parasite-attack1-top-left-5',
          'parasite-attack1-top-left-6',
          'parasite-attack1-top-left-7',
          'parasite-attack1-top-left-8',
        ],
        'parasite-attack1-top': [
          'parasite-attack1-top-0',
          'parasite-attack1-top-1',
          'parasite-attack1-top-2',
          'parasite-attack1-top-3',
          'parasite-attack1-top-4',
          'parasite-attack1-top-5',
          'parasite-attack1-top-6',
          'parasite-attack1-top-7',
          'parasite-attack1-top-8',
        ],
      },
    },
  },
  {
    name: 'parasite-attack2',
    metadata: {
      frames: {
        'parasite-attack2-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-attack2-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/parasite/attack2.png',
        size: {
          w: 2304,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'parasite-attack2-bottom': [
          'parasite-attack2-bottom-0',
          'parasite-attack2-bottom-1',
          'parasite-attack2-bottom-2',
          'parasite-attack2-bottom-3',
          'parasite-attack2-bottom-4',
          'parasite-attack2-bottom-5',
          'parasite-attack2-bottom-6',
          'parasite-attack2-bottom-7',
          'parasite-attack2-bottom-8',
        ],
        'parasite-attack2-bottom-left': [
          'parasite-attack2-bottom-left-0',
          'parasite-attack2-bottom-left-1',
          'parasite-attack2-bottom-left-2',
          'parasite-attack2-bottom-left-3',
          'parasite-attack2-bottom-left-4',
          'parasite-attack2-bottom-left-5',
          'parasite-attack2-bottom-left-6',
          'parasite-attack2-bottom-left-7',
          'parasite-attack2-bottom-left-8',
        ],
        'parasite-attack2-left': [
          'parasite-attack2-left-0',
          'parasite-attack2-left-1',
          'parasite-attack2-left-2',
          'parasite-attack2-left-3',
          'parasite-attack2-left-4',
          'parasite-attack2-left-5',
          'parasite-attack2-left-6',
          'parasite-attack2-left-7',
          'parasite-attack2-left-8',
        ],
        'parasite-attack2-top-left': [
          'parasite-attack2-top-left-0',
          'parasite-attack2-top-left-1',
          'parasite-attack2-top-left-2',
          'parasite-attack2-top-left-3',
          'parasite-attack2-top-left-4',
          'parasite-attack2-top-left-5',
          'parasite-attack2-top-left-6',
          'parasite-attack2-top-left-7',
          'parasite-attack2-top-left-8',
        ],
        'parasite-attack2-top': [
          'parasite-attack2-top-0',
          'parasite-attack2-top-1',
          'parasite-attack2-top-2',
          'parasite-attack2-top-3',
          'parasite-attack2-top-4',
          'parasite-attack2-top-5',
          'parasite-attack2-top-6',
          'parasite-attack2-top-7',
          'parasite-attack2-top-8',
        ],
      },
    },
  },
  {
    name: 'parasite-awake',
    metadata: {
      frames: {
        'parasite-awake-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-awake-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/parasite/awake.png',
        size: {
          w: 2048,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'parasite-awake-bottom': [
          'parasite-awake-bottom-0',
          'parasite-awake-bottom-1',
          'parasite-awake-bottom-2',
          'parasite-awake-bottom-3',
          'parasite-awake-bottom-4',
          'parasite-awake-bottom-5',
          'parasite-awake-bottom-6',
          'parasite-awake-bottom-7',
        ],
        'parasite-awake-bottom-left': [
          'parasite-awake-bottom-left-0',
          'parasite-awake-bottom-left-1',
          'parasite-awake-bottom-left-2',
          'parasite-awake-bottom-left-3',
          'parasite-awake-bottom-left-4',
          'parasite-awake-bottom-left-5',
          'parasite-awake-bottom-left-6',
          'parasite-awake-bottom-left-7',
        ],
        'parasite-awake-left': [
          'parasite-awake-left-0',
          'parasite-awake-left-1',
          'parasite-awake-left-2',
          'parasite-awake-left-3',
          'parasite-awake-left-4',
          'parasite-awake-left-5',
          'parasite-awake-left-6',
          'parasite-awake-left-7',
        ],
        'parasite-awake-top-left': [
          'parasite-awake-top-left-0',
          'parasite-awake-top-left-1',
          'parasite-awake-top-left-2',
          'parasite-awake-top-left-3',
          'parasite-awake-top-left-4',
          'parasite-awake-top-left-5',
          'parasite-awake-top-left-6',
          'parasite-awake-top-left-7',
        ],
        'parasite-awake-top': [
          'parasite-awake-top-0',
          'parasite-awake-top-1',
          'parasite-awake-top-2',
          'parasite-awake-top-3',
          'parasite-awake-top-4',
          'parasite-awake-top-5',
          'parasite-awake-top-6',
          'parasite-awake-top-7',
        ],
      },
    },
  },
  {
    name: 'parasite-death',
    metadata: {
      frames: {
        'parasite-death-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-death-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/parasite/death.png',
        size: {
          w: 2304,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'parasite-death-bottom': [
          'parasite-death-bottom-0',
          'parasite-death-bottom-1',
          'parasite-death-bottom-2',
          'parasite-death-bottom-3',
          'parasite-death-bottom-4',
          'parasite-death-bottom-5',
          'parasite-death-bottom-6',
          'parasite-death-bottom-7',
          'parasite-death-bottom-8',
        ],
        'parasite-death-bottom-left': [
          'parasite-death-bottom-left-0',
          'parasite-death-bottom-left-1',
          'parasite-death-bottom-left-2',
          'parasite-death-bottom-left-3',
          'parasite-death-bottom-left-4',
          'parasite-death-bottom-left-5',
          'parasite-death-bottom-left-6',
          'parasite-death-bottom-left-7',
          'parasite-death-bottom-left-8',
        ],
        'parasite-death-left': [
          'parasite-death-left-0',
          'parasite-death-left-1',
          'parasite-death-left-2',
          'parasite-death-left-3',
          'parasite-death-left-4',
          'parasite-death-left-5',
          'parasite-death-left-6',
          'parasite-death-left-7',
          'parasite-death-left-8',
        ],
        'parasite-death-top-left': [
          'parasite-death-top-left-0',
          'parasite-death-top-left-1',
          'parasite-death-top-left-2',
          'parasite-death-top-left-3',
          'parasite-death-top-left-4',
          'parasite-death-top-left-5',
          'parasite-death-top-left-6',
          'parasite-death-top-left-7',
          'parasite-death-top-left-8',
        ],
        'parasite-death-top': [
          'parasite-death-top-0',
          'parasite-death-top-1',
          'parasite-death-top-2',
          'parasite-death-top-3',
          'parasite-death-top-4',
          'parasite-death-top-5',
          'parasite-death-top-6',
          'parasite-death-top-7',
          'parasite-death-top-8',
        ],
      },
    },
  },
  {
    name: 'parasite-hit',
    metadata: {
      frames: {
        'parasite-hit-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-hit-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/parasite/hit.png',
        size: {
          w: 1536,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'parasite-hit-bottom': [
          'parasite-hit-bottom-0',
          'parasite-hit-bottom-1',
          'parasite-hit-bottom-2',
          'parasite-hit-bottom-3',
          'parasite-hit-bottom-4',
          'parasite-hit-bottom-5',
        ],
        'parasite-hit-bottom-left': [
          'parasite-hit-bottom-left-0',
          'parasite-hit-bottom-left-1',
          'parasite-hit-bottom-left-2',
          'parasite-hit-bottom-left-3',
          'parasite-hit-bottom-left-4',
          'parasite-hit-bottom-left-5',
        ],
        'parasite-hit-left': [
          'parasite-hit-left-0',
          'parasite-hit-left-1',
          'parasite-hit-left-2',
          'parasite-hit-left-3',
          'parasite-hit-left-4',
          'parasite-hit-left-5',
        ],
        'parasite-hit-top-left': [
          'parasite-hit-top-left-0',
          'parasite-hit-top-left-1',
          'parasite-hit-top-left-2',
          'parasite-hit-top-left-3',
          'parasite-hit-top-left-4',
          'parasite-hit-top-left-5',
        ],
        'parasite-hit-top': [
          'parasite-hit-top-0',
          'parasite-hit-top-1',
          'parasite-hit-top-2',
          'parasite-hit-top-3',
          'parasite-hit-top-4',
          'parasite-hit-top-5',
        ],
      },
    },
  },
  {
    name: 'parasite-idle',
    metadata: {
      frames: {
        'parasite-idle-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-8': {
          frame: {
            x: 2048,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-bottom-left-8': {
          frame: {
            x: 2048,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-left-8': {
          frame: {
            x: 2048,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-left-8': {
          frame: {
            x: 2048,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-idle-top-8': {
          frame: {
            x: 2048,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/parasite/idle.png',
        size: {
          w: 2304,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'parasite-idle-bottom': [
          'parasite-idle-bottom-0',
          'parasite-idle-bottom-1',
          'parasite-idle-bottom-2',
          'parasite-idle-bottom-3',
          'parasite-idle-bottom-4',
          'parasite-idle-bottom-5',
          'parasite-idle-bottom-6',
          'parasite-idle-bottom-7',
          'parasite-idle-bottom-8',
        ],
        'parasite-idle-bottom-left': [
          'parasite-idle-bottom-left-0',
          'parasite-idle-bottom-left-1',
          'parasite-idle-bottom-left-2',
          'parasite-idle-bottom-left-3',
          'parasite-idle-bottom-left-4',
          'parasite-idle-bottom-left-5',
          'parasite-idle-bottom-left-6',
          'parasite-idle-bottom-left-7',
          'parasite-idle-bottom-left-8',
        ],
        'parasite-idle-left': [
          'parasite-idle-left-0',
          'parasite-idle-left-1',
          'parasite-idle-left-2',
          'parasite-idle-left-3',
          'parasite-idle-left-4',
          'parasite-idle-left-5',
          'parasite-idle-left-6',
          'parasite-idle-left-7',
          'parasite-idle-left-8',
        ],
        'parasite-idle-top-left': [
          'parasite-idle-top-left-0',
          'parasite-idle-top-left-1',
          'parasite-idle-top-left-2',
          'parasite-idle-top-left-3',
          'parasite-idle-top-left-4',
          'parasite-idle-top-left-5',
          'parasite-idle-top-left-6',
          'parasite-idle-top-left-7',
          'parasite-idle-top-left-8',
        ],
        'parasite-idle-top': [
          'parasite-idle-top-0',
          'parasite-idle-top-1',
          'parasite-idle-top-2',
          'parasite-idle-top-3',
          'parasite-idle-top-4',
          'parasite-idle-top-5',
          'parasite-idle-top-6',
          'parasite-idle-top-7',
          'parasite-idle-top-8',
        ],
      },
    },
  },
  {
    name: 'parasite-startWalk',
    metadata: {
      frames: {
        'parasite-startWalk-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-startWalk-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/parasite/startWalk.png',
        size: {
          w: 1536,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'parasite-startWalk-bottom': [
          'parasite-startWalk-bottom-0',
          'parasite-startWalk-bottom-1',
          'parasite-startWalk-bottom-2',
          'parasite-startWalk-bottom-3',
          'parasite-startWalk-bottom-4',
          'parasite-startWalk-bottom-5',
        ],
        'parasite-startWalk-bottom-left': [
          'parasite-startWalk-bottom-left-0',
          'parasite-startWalk-bottom-left-1',
          'parasite-startWalk-bottom-left-2',
          'parasite-startWalk-bottom-left-3',
          'parasite-startWalk-bottom-left-4',
          'parasite-startWalk-bottom-left-5',
        ],
        'parasite-startWalk-left': [
          'parasite-startWalk-left-0',
          'parasite-startWalk-left-1',
          'parasite-startWalk-left-2',
          'parasite-startWalk-left-3',
          'parasite-startWalk-left-4',
          'parasite-startWalk-left-5',
        ],
        'parasite-startWalk-top-left': [
          'parasite-startWalk-top-left-0',
          'parasite-startWalk-top-left-1',
          'parasite-startWalk-top-left-2',
          'parasite-startWalk-top-left-3',
          'parasite-startWalk-top-left-4',
          'parasite-startWalk-top-left-5',
        ],
        'parasite-startWalk-top': [
          'parasite-startWalk-top-0',
          'parasite-startWalk-top-1',
          'parasite-startWalk-top-2',
          'parasite-startWalk-top-3',
          'parasite-startWalk-top-4',
          'parasite-startWalk-top-5',
        ],
      },
    },
  },
  {
    name: 'parasite-walk',
    metadata: {
      frames: {
        'parasite-walk-bottom-0': {
          frame: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-1': {
          frame: {
            x: 256,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-2': {
          frame: {
            x: 512,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-3': {
          frame: {
            x: 768,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-4': {
          frame: {
            x: 1024,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-5': {
          frame: {
            x: 1280,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-6': {
          frame: {
            x: 1536,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-7': {
          frame: {
            x: 1792,
            y: 0,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-left-0': {
          frame: {
            x: 0,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-left-1': {
          frame: {
            x: 256,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-left-2': {
          frame: {
            x: 512,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-left-3': {
          frame: {
            x: 768,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-left-4': {
          frame: {
            x: 1024,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-left-5': {
          frame: {
            x: 1280,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-left-6': {
          frame: {
            x: 1536,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-bottom-left-7': {
          frame: {
            x: 1792,
            y: 256,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-left-0': {
          frame: {
            x: 0,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-left-1': {
          frame: {
            x: 256,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-left-2': {
          frame: {
            x: 512,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-left-3': {
          frame: {
            x: 768,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-left-4': {
          frame: {
            x: 1024,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-left-5': {
          frame: {
            x: 1280,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-left-6': {
          frame: {
            x: 1536,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-left-7': {
          frame: {
            x: 1792,
            y: 512,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-left-0': {
          frame: {
            x: 0,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-left-1': {
          frame: {
            x: 256,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-left-2': {
          frame: {
            x: 512,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-left-3': {
          frame: {
            x: 768,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-left-4': {
          frame: {
            x: 1024,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-left-5': {
          frame: {
            x: 1280,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-left-6': {
          frame: {
            x: 1536,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-left-7': {
          frame: {
            x: 1792,
            y: 768,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-0': {
          frame: {
            x: 0,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-1': {
          frame: {
            x: 256,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-2': {
          frame: {
            x: 512,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-3': {
          frame: {
            x: 768,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-4': {
          frame: {
            x: 1024,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-5': {
          frame: {
            x: 1280,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-6': {
          frame: {
            x: 1536,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
        'parasite-walk-top-7': {
          frame: {
            x: 1792,
            y: 1024,
            w: 256,
            h: 256,
          },
          sourceSize: {
            w: 256,
            h: 256,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 256,
            h: 256,
          },
        },
      },
      meta: {
        image: '/sprites/entities/parasite/walk.png',
        size: {
          w: 2048,
          h: 1280,
        },
        scale: '1',
      },
      animations: {
        'parasite-walk-bottom': [
          'parasite-walk-bottom-0',
          'parasite-walk-bottom-1',
          'parasite-walk-bottom-2',
          'parasite-walk-bottom-3',
          'parasite-walk-bottom-4',
          'parasite-walk-bottom-5',
          'parasite-walk-bottom-6',
          'parasite-walk-bottom-7',
        ],
        'parasite-walk-bottom-left': [
          'parasite-walk-bottom-left-0',
          'parasite-walk-bottom-left-1',
          'parasite-walk-bottom-left-2',
          'parasite-walk-bottom-left-3',
          'parasite-walk-bottom-left-4',
          'parasite-walk-bottom-left-5',
          'parasite-walk-bottom-left-6',
          'parasite-walk-bottom-left-7',
        ],
        'parasite-walk-left': [
          'parasite-walk-left-0',
          'parasite-walk-left-1',
          'parasite-walk-left-2',
          'parasite-walk-left-3',
          'parasite-walk-left-4',
          'parasite-walk-left-5',
          'parasite-walk-left-6',
          'parasite-walk-left-7',
        ],
        'parasite-walk-top-left': [
          'parasite-walk-top-left-0',
          'parasite-walk-top-left-1',
          'parasite-walk-top-left-2',
          'parasite-walk-top-left-3',
          'parasite-walk-top-left-4',
          'parasite-walk-top-left-5',
          'parasite-walk-top-left-6',
          'parasite-walk-top-left-7',
        ],
        'parasite-walk-top': [
          'parasite-walk-top-0',
          'parasite-walk-top-1',
          'parasite-walk-top-2',
          'parasite-walk-top-3',
          'parasite-walk-top-4',
          'parasite-walk-top-5',
          'parasite-walk-top-6',
          'parasite-walk-top-7',
        ],
      },
    },
  },
];
